module.exports = __webpack_public_path__ + "img/teams-ia.ab7b7cc5.svg";